module.exports = __webpack_public_path__ + "static/logo-omega-station-6c7f34f4f2380815af50d3f3fc5c466c.svg";